var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLedger = function SvgLedger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 768.91 669.35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 479.29v190.06h289.22V627.2H42.14V479.29zm726.77 0V627.2H479.69v42.14h289.22V479.29zM289.64 190.06v289.22h190.05v-38.01H331.78V190.06zM0 0v190.06h42.14V42.14h247.08V0zm479.69 0v42.14h247.08v147.92h42.14V0z"
  })));
};
export default SvgLedger;